import React from 'react';
import PropTypes from 'prop-types';
import MatchArrowIcon from 'screens/Integrations/PropertiesMatch/components/FarmList/components/icons/MatchArrowIcon';
import { Tag, Switch } from 'syngenta-digital-cropwise-react-ui-kit';
import CompanyPeopleDropdown from 'components/CompanyPeopleDropdown';

const RetailerListItem = ({
  retailer,
  matchedRetailer = undefined,
  createNewRetailer = false,
  handleSelect,
  handleCreateNewRetailer
}) => {
  return (
    <div className="justify-self-start pr-15 col-span-w w-full mb-3">
      <div className="grid items-center grid-cols-7">
        <div className="text-sm col-span-3" style={{ position: 'relative' }}>
          <div className="flex flex-row items-center">
            <div className="mr-4 mt-6 flex-none w-22">
              <Tag
                key="retailer-status"
                color={
                  matchedRetailer || createNewRetailer ? 'green' : 'yellow'
                }
                data-testid="status-tag"
                style={{ padding: '0.5rem', lineHeight: '1px' }}
              >
                {matchedRetailer || createNewRetailer ? 'MATCHED' : 'UNMATCHED'}
              </Tag>
            </div>
            <div className="flex flex-col w-full">
              <span className="text-gray-600">Retailer</span>
              <div className="mt-1 px-2 py-1 rounded-md bg-gray-200 border-gray-500 border text-gray-600">{`${retailer.retailerName}`}</div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center h-full col-span-1">
          <span className="mb-1 mt-6">
            <MatchArrowIcon />
          </span>
        </div>
        <div className="flex flex-col col-span-3 mt-7">
          <div
            className="text-neutral-600 text-left mb-1 text-sm"
            data-testid="cropzones-heading"
          >
            Cropwise Financials Company
          </div>
          <div className="flex items-center justify-center cropzone-dropdown">
            {createNewRetailer ? (
              <div className="w-full">
                <div className="px-2 py-1 rounded-md bg-gray-200 border-gray-500 border text-gray-600">
                  New company record by Retailer
                </div>
              </div>
            ) : (
              <CompanyPeopleDropdown
                id="cwfRetailerMatch"
                value={
                  matchedRetailer
                    ? { ...matchedRetailer, type: 'Company' }
                    : null
                }
                onChange={value => {
                  handleSelect(value);
                }}
                bottomButtonText="Create New Company"
                title="Create a Company"
                hidePeople
                disableDrawerTypeChange
                hideIcon
              />
            )}
          </div>
          <div className="my-auto pt-2">
            <Switch
              size="medium"
              checked={createNewRetailer}
              onChange={handleCreateNewRetailer}
            />
            <span className="ml-2">
              Use retailer to create new company record
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

RetailerListItem.propTypes = {
  retailer: PropTypes.shape({
    externalId: PropTypes.string,
    retailerName: PropTypes.string
  }).isRequired,
  matchedRetailer: PropTypes.shape({
    vendorEntityDescription: PropTypes.string,
    vendorEntityId: PropTypes.string,
    cwfEntityId: PropTypes.string,
    type: PropTypes.string
  }),
  createNewRetailer: PropTypes.bool,
  handleSelect: PropTypes.func.isRequired,
  handleCreateNewRetailer: PropTypes.func.isRequired
};

export default RetailerListItem;
